import { AfterViewInit, Component, ViewChild, ElementRef } from "@angular/core";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { NavController } from "@ionic/angular";
import { take, catchError, EMPTY } from "rxjs";

@Component({
    selector: "app-sovendus-page",
    templateUrl: "./sovendus-page.component.html",
    styleUrl: "./sovendus-page.component.scss",
    standalone: true,
})
export class SovendusPageComponent implements AfterViewInit {
  userDetails: Data;
  @ViewChild('sovendusIframe') sovendusIframe: ElementRef<HTMLIFrameElement>;
  private wrapperReady = false;

  constructor(
    private authService: AuthService, 
    private navCtrl: NavController
  ) {}

  ngAfterViewInit(): void {
    this.setupMessageListener();
    this.getUserDetails();
  }

  /**
   * Setup message listener to handle wrapper ready notification
   */
  private setupMessageListener(): void {
    try {
      window.addEventListener('message', (event) => {
        if (event.data && event.data.type === 'sovendus-wrapper-ready') {
          this.wrapperReady = true;
          // Send user details to wrapper if available
          if (this.userDetails) {
            this.sendUserDetailsToWrapper();
          }
        }
      });
    } catch (error) {
      console.warn('[Sovendus] Error setting up message listener:', error);
    }
  }

  getUserDetails() {
    try {
      this.authService?.userDetails$
        ?.pipe(
          take(1),
          catchError((err) => {
            console.warn('[Sovendus] Error fetching user details:', err);
            return EMPTY;
          }),
        )
        .subscribe((user) => {
          this.userDetails = user;
          // Send to wrapper if ready, otherwise it will be sent when wrapper becomes ready
          if (this.wrapperReady) {
            this.sendUserDetailsToWrapper();
          }
        });
    } catch (error) {
      return error;
    }
  }

  /**
   * Send user details to the Sovendus wrapper iframe via postMessage
   */
  private sendUserDetailsToWrapper(): void {
    try {
      if (!this.userDetails) {
        console.warn('[Sovendus] User details not available, skipping');
        return;
      }

      if (!this.sovendusIframe || !this.sovendusIframe.nativeElement) {
        console.warn('[Sovendus] Iframe reference not available');
        return;
      }

      const iframeWindow = this.sovendusIframe.nativeElement.contentWindow;
      if (!iframeWindow) {
        console.warn('[Sovendus] Iframe window not accessible');
        return;
      }

      // Send user details to wrapper
      iframeWindow.postMessage({
        type: 'sovendus-user-details',
        payload: this.userDetails
      }, '*');
    } catch (error) {
      console.warn('[Sovendus] Failed to send user details to wrapper:', error);
    }
  }



  goBack() {
    this.navCtrl.back();
  }
}
